module.exports = __webpack_public_path__ + "img/arrow.b1285f46.svg";